export default {
    init() {
        let btn = document.getElementById('back-to-top');
        if(btn) {
            btn.addEventListener('click', (e) => {
                let top = document.querySelector('.network__title');
                if(top) {
                    top.scrollIntoView({
                        behavior: "smooth",
                        block: "start"
                    });
                }
            })
        }
    }
}